import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Label, Icon} from 'semantic-ui-react';
import ServiceReportPartTable from './table';


class InfoDetail extends Component {
  getValue = (value) => {
    if (typeof value === 'undefined' || isNaN(value.totalRate)) {
      return 0;
    }
    return value.totalRate;
  }

  render() {
    const {
      dealer,
      dealerName,
      serviceFee,
      ordersServed,
      orders,
      agencies,
      isUserFromTDE,
      setDealerDetail,
    } = this.props;

    return (
      <Card raised fluid className={isUserFromTDE ? 'half' : 'full'}>
        {isUserFromTDE && (
          <Icon name="close" onClick={() => setDealerDetail()} size='large' />
        )}
        <Card.Content>
          <Card.Header>{dealer || dealerName}</Card.Header>
          <div className="totals-service-rate-labels">
            <Label className="service-rate-total">
              <div className="calendarioTems-sb">
                <span>Tasa de Servicio</span>
                <span>{serviceFee.toFixed(2)}%</span>
              </div>
            </Label>
            <Label className="service-rate-total">
              <div className="calendarioTems-sb">
                <span>Líneas de Pedidos</span>
                <span>{orders}</span>
              </div>
            </Label>
            <Label className="service-rate-total">
              <div className="calendarioTems-sb">
                <span>Líneas Atendidas</span>
                <span>{ordersServed}</span>
              </div>
            </Label>
          </div>
          <Card.Description>
            <ServiceReportPartTable list={agencies} linesSize={isUserFromTDE ? 4 : 5} />
          </Card.Description>
        </Card.Content>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'serviceRateList': state.serviceRate.list,
    'serviceRateLoading': state.serviceRate.loading,
    'isUserFromTDE': state.session.isUserFromTDE,
    'dealerName': state.dealer.dealerInfo?.name,
  };
};

export default connect(mapStateToProps, {})(InfoDetail);
